// extracted by mini-css-extract-plugin
module.exports = {"deprecatedWrapper":"GeoGebraInteraction__deprecatedWrapper___nUa6a"};